import { MutationHookOptions, MutationTuple, useMutation } from '@apollo/client'
import {
  deleteReferralVariables,
  deleteReferral,
} from '../../../../models/graphqlTypes'

import { DELETE_REFERRAL } from '../../../../operations/patientReferralOperations'

type Options = MutationHookOptions<deleteReferral, deleteReferralVariables>

type Return = MutationTuple<deleteReferral, deleteReferralVariables>

export const useDeleteReferral = (options: Options = {}): Return => {
  return useMutation<deleteReferral, deleteReferralVariables>(
    DELETE_REFERRAL,
    options
  )
}
